

export class VehicleDocumentDetailsStatusInput implements IVehicleDocumentDetailsStatusInput {
    /** The auto-generated id of the vehicle details document master */
    vehicleDetailsDocumentId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IVehicleDocumentDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleDetailsDocumentId = _data["vehicleDetailsDocumentId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleDocumentDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDocumentDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleDetailsDocumentId"] = this.vehicleDetailsDocumentId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleDocumentDetailsStatusInput {
    /** The auto-generated id of the vehicle details document master */
    vehicleDetailsDocumentId: number;
    /** The updated status */
    status: number;
}

